import React, { useCallback, useMemo, useRef, useState } from 'react';
import qs from 'query-string';
import { Map } from '@/components/Search';
import { getSearch, SaveApiResMessage } from '@/actions';
import { _get, noScroll, removeNoScroll } from '@/actions/Helper';
import { ParseMarketPlaceForm } from '@/actions/ParseData';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import ReservePupop from '../Search/ReservePupop';
import SearchFilter from '../Search/SearchFilter';
import SearchResultListView from '../Search/ListView';
import { Icon } from '@/components/Icon';
import { Icons } from '@/assets';
import { useSelector } from 'react-redux';

const EmptySearchDetail = ({ history }) => {
  const selectOp = useSelector((state) => state.reducer);

  const scrolledContainerRef = useRef(null);

  const [reserveInformation, setReserveInformation] = useState({
    item: null,
    open: false,
  });
  const [formData, setFormData] = useState({
    specification_id: null,
    company_id: null,
    loc: null,
    count: null,
    date: new Date(),
    chassis: {
      own: false,
      pool: false,
    },
  });
  const [state, setState] = React.useState({
    loading: true,
    DATA: [],
    RemNum: 0,
  });

  const query = useMemo(
    () => qs.parse(_get(history, 'location.search', null)),
    [history.location.search]
  );

  const handleQuery = useCallback(() => {
    setFormData({
      specification_id: {
        value: query.size,
        label: selectOp.size.find((item) => item.value === +query.size)?.label,
      },
      company_id: {
        value: query.ssl,
        label: selectOp.ssl.find((item) => item.value === +query.ssl)?.label,
      },
      loc: {
        value: {
          address: query.address,
          city: query.city,
          lat: query.lat,
          lng: query.long,
        },
        label: query.address,
      },
      count: query.count,
      date: new Date(query.date),
      chassis: {
        own: query.chases === 'own' || !query.chases,
        pool: query.chases === 'pool' || !query.chases,
      },
    });
  }, [query, selectOp]);

  const fetchSearches = useCallback(() => {
    getSearch(query)
      .then((res) => {
        setState({
          DATA: res,
          loading: false,
          RemNum: query.count,
        });
      })
      .catch((err) => {
        console.error({ err });

        setState({
          DATA: [],
          loading: false,
        });
      });
  }, [query]);

  React.useEffect(() => {
    if (query) {
      fetchSearches();
    }
  }, [query, fetchSearches]);

  React.useEffect(() => {
    if (query) {
      handleQuery();
    }
  }, [query, handleQuery, selectOp]);

  const activeNotify = () => {
    getSearch({ ...query, save_search: true })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'success',
          mode: 'success',
        });
      })
      .catch((err) => {
        if (err.includes('No Inventory has been found for this search')) {
          SaveApiResMessage({
            title: null,
            message:
              'You will be notified when a matching container is added to the platform .',
            mode: 'success',
          });
        } else {
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
        }
      });
  };

  const setForm = (it, val) => setFormData({ ...formData, [it]: val });

  const submitSearch = () => {
    history.push(
      '/search-detail/empty?' + qs.stringify(ParseMarketPlaceForm(formData))
    );
  };

  const smart = () => {
    getSearch({ ...query, t: 'smart' })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Smart Search created.',
          mode: 'success',
        });
        history.push('/requests');
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const closeReserve = () => {
    removeNoScroll();
    setReserveInformation({
      item: null,
      open: false,
    });
  };

  const openReserve = (item) => {
    noScroll();
    setReserveInformation({
      item: item,
      open: true,
    });
  };

  return (
    <PageContainerAB title="Search Result" minWidth={'unset'}>
      <div className="flex flex-col">
        {reserveInformation.open && (
          <ReservePupop
            item={reserveInformation.item}
            query={query}
            CloseReserve={closeReserve}
          />
        )}

        <SearchFilter
          formData={formData}
          setForm={setForm}
          onSubmit={submitSearch}
          activeNotify={activeNotify}
          hasResetButton
        />

        {state.DATA.length > 0 && (
          <div className="flex-shrink-0 border border-border-tertiary shadow-table-header border-solid rounded-lg p-4 flex justify-center items-center my-4">
            <Icon src={Icons.searchTick} width={24} height={24} />
            <p className="text-inactive-text text-base font-bold  m-0 ml-2">
              According to your search criteria, a total of
              <span className="text-primary-text ">
                {' '}
                {state.DATA.length} active offers
              </span>{' '}
              are currently available
            </p>
          </div>
        )}
        <div className="flex flex-col flex-1 sm:min-h-0">
          <div ref={scrolledContainerRef}>
            <SearchResultListView
              scrolledContainerRef={scrolledContainerRef}
              loading={state.loading}
              DATA={state.DATA}
              openReserve={openReserve}
              setReserveInformation={setReserveInformation}
              reservedItem={reserveInformation.item}
              activeNotify={activeNotify}
              noCountChange
            />
          </div>
          {state.DATA.length > 0 && (
            <div className="w-full flex-shrink-0 pt-4">
              <div
                className="border border-solid pb-4 px-4 rounded-xl "
                style={{
                  height: 342,
                }}>
                <div className="flex justify-between items-center">
                  <h2 className="text-lg m-0 font-bold flex items-center gap-2 py-4">
                    <Icon src={Icons.mapPin} width={24} height={24} />
                    Live Map
                  </h2>
                </div>
                <hr className="mb-4 mt-0  border-t border-solid" />
                <div>
                  <Map
                    DATA={state.DATA}
                    smart={smart}
                    className="h-264"
                    onMarkerClick={(item) => {
                      const fullItem = state.DATA.find(
                        (dataItem) =>
                          dataItem.id === item.id ||
                          (dataItem.ssl === item.ssl &&
                            dataItem.loc === item.loc)
                      );
                      console.log({ fullItem, item });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </PageContainerAB>
  );
};

export default EmptySearchDetail;
